import React, { useState, useEffect } from 'react';

import { get } from '../services/api';
import Loading from './Loading/Loading';
import PowerfulTable from './PowerfulTable/PowerfulTable';

const TeachersList = (props) => {

  const [teachers, setTeachers] = useState(null);
  useEffect(() => {
    let isMounted = true;

    const fetchTeachers = async () => {
      // 1. Initial load
      const initialTeachers = await get('/admin/teachers?limit=50');
      if (isMounted) {
        setTeachers(initialTeachers || []);
      }

      // 2. Background load
      get('/admin/teachers?limit=10000&skip=50').then(rest => {
        if (isMounted && rest && rest.length > 0) {
          setTeachers(prev => {
            const existingIds = new Set(prev.map(t => t._id));
            const newUniqueTeachers = rest.filter(t => !existingIds.has(t._id));
            return [...prev, ...newUniqueTeachers];
          });
        }
      });
    };

    fetchTeachers();

    return () => { isMounted = false; };
  }, []);

  if (!teachers) return <Loading />

  return (
    <div style={{ marginLeft: 20, width: '100%', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Professeurs ({teachers ? teachers.length : 0})</h2>
      </div>

      <PowerfulTable
        data={teachers}
        types={{
          _id: { name: 'email' },
          firstname: { name: 'prénom' },
          lastname: { name: 'nom' },
          number: { name: 'téléphone' },
          pictureValidated: { name: 'photo validée' },
          filledCv: { name: 'CV rempli' },
          rate: { name: 'note' },
          signup: { name: 'inscription' },
        }}
        redirect={'teachers'}
        redirectKey={'_id'}
      />
    </div>
  );
};

export default TeachersList;
